import { render, staticRenderFns } from "./PageAlert.vue?vue&type=template&id=1199ea00&"
import script from "./PageAlert.vue?vue&type=script&lang=js&"
export * from "./PageAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports